import { defineComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex'
import approval from './Approval/Approval.vue'
import license from './License/License.vue'
import retraction from './Retraction/Retraction.vue'

export default defineComponent ({
    name: 'letter'
    , props: {
        isEditApproval: {
            type: Boolean
            , required: false
            , default: false
        }
        , objectEditApproval: {
            type: Array
            , required: false
            , default: () => ([])
        }
        , isEditRetraction: {
            type: Boolean
            , required: false
            , default: false
        }
        , objectEditRetraction: {
            type: Object
            , required: false
            , default: () => ({})
        },
        dataAvailableTickets: {
            type: Object
            , required: false
            , default: () => ({})
        }
    }
    , components: {
        approval
        , license
        , retraction
    }
    , data: () => ({
         can_be_downloaded_approval: false
        , can_be_downloaded_retraction: false
    })
    , computed: {
        downloadLicense () {
            return this.backendPath.concat(`/v2/licenses/${this.id}/download-in-pdf`)
        }
        , downloadResponse () {
            return (type = 'approval') => this.backendPath.concat(`/v2/licenses/${this.id}/download-${type}-in-pdf`)
        }
        , id () {
            return Number(this.$route.params.id || 0)
        }
        , show () {
            return this.getProcessingLicense === false
        }
        , ...mapGetters('permisosSindicalesV2License' ,[
            'getProcessingLicense'
        ])
    }
    , async beforeMount () {
        await this.getLicenseAction({ id: this.id, dataAvailableTickets: this.dataAvailableTickets })
        this.can_be_downloaded_approval = this.$refs.approval ? this.$refs.approval.canBeDownloaded : false
    }
    , methods: {
        ...mapActions('permisosSindicalesV2License', [
            'getLicenseAction'
        ])
        , changedCanBeDownload ( { value } ) {
            this.can_be_downloaded_retraction = value
        }
    }
})